<template>
     <q-modal v-model="show_preview" :content-css="{maxWidth: getMaxWidth, minWidth: getMinWidth}" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_preview = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t(game_name) }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row q-pa-xs">
                    <div class="col-12">
                        <p class="text-bold">{{ $t('game_preview') }}</p>

                        <span v-for="(word, index) in game_words" :key="index">
                            <q-chip v-if="changeElement(index)" square
                                class="word-chip font-bigger q-ma-xs"
                                :class="options[getInputPosition(index)].correct ? 'bg-green-4' : 'bg-red-4'"
                                :id="`chip-${index}`">

                                {{ options[getInputPosition(index)].value }}
                                <q-icon class="q-ml-sm" size="sm" :name="options[getInputPosition(index)].correct ? 'far fa-check' : 'far fa-times'" />
                            </q-chip>
                            <span v-if="word !== 'SPECIAL_WORD' && word.includes('\n')" class="font-bigger"><br />{{ `${word} ` }}</span>
                            <span v-else-if="word !== 'SPECIAL_WORD'" class="font-bigger">{{ `${word} ` }}</span>
                            <span v-else>
                              <q-input
                                v-if="options[getInputPosition(index)].correct === undefined"
                                v-model="options[getInputPosition(index)].value"
                                autocomplete="off"
                                no-parent-field
                                align="center"
                                class="word-input q-mx-sm bg-grey-2"
                                :readonly="game_finished"
                                :id="`input-${index}`"
                                :style="{ width: getWordSlotWidth, background: 'red' }"
                                @blur="options[getInputPosition(index)].value ? checkAnswer(index) : null"
                                />
                            </span>
                        </span>
                    </div>

                    <div class="col-10 q-mt-lg" v-if="game_finished">
                        <p class="text-bold q-mt-sm">{{ $t('result') }}</p>

                        <q-slider disable markers snap
                            v-model="user_score" :color="game_finished ? getSliderColor() : 'blue-6'"
                            :min="0"
                            :max="number_of_choices"
                            />

                        <p class="q-mt-sm">{{ `${$t('correct_answers')}: ${user_score} / ${number_of_choices}` }}</p>
                        <p v-if="user_won">{{ $t(success_message) }}</p>
                        <p v-else>{{ $t(failure_message) }}</p>
                    </div>
                </div>

                <div class="col-xs-12 q-mt-md">
                    <div class="row justify-end">
                        <q-btn color="secondary" :label="$t('back')" @click="show_preview = false" />
                        <q-btn v-if="!game_finished && this.options.filter(e => e.value).length === this.options.length" color="primary"  class="q-ml-md" :label="$t('answer')" @click="checkResults" />
                        <q-btn v-if="game_finished" color="primary"  class="q-ml-md" :label="$t('play_again')" @click="resetGame" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import slugify from '../../../functions/slugify.js'

export default {
    name: 'AdminGameFillInTheBlanksPreview',

    props: ['show_game_preview', 'game_name', 'game_words_arr', 'game_options', 'word_slot'],

    data() {
        return {
          options: [],
          game_words: [],
          game_finished: false,
          number_of_choices: 0,
          correct_choices: 0,
          user_score: 0,
          user_won: false,
          success_message: `${this.game_name}_success_message`,
          failure_message: `${this.game_name}_failure_message`,
        }
    },

    computed: {
        show_preview: {
            get() {
                return this.show_game_preview
            },
            set() {
                this.$emit('hide_preview', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '90vw'
            else return '75vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '50vw'
        },

        getWordSlotWidth() {
          if (this.$q.platform.is.mobile) return `${(this.word_slot.length + 1) * 12}px`
          else return `${(this.word_slot.length + 1) * 16}px`
        }

    },

    methods: {
        getInputPosition(index) {
            let inputPos = this.options.findIndex(e => e.position === index)
            return inputPos
        },

        changeElement(index) {
            let wordValue = this.options.find(e => e.position === index)
            if (wordValue) {
                if (wordValue.correct === true || wordValue.correct === false)  return true
            }
            else return false
        },

        checkAnswer(index) {
            let wordValue = this.options.find(e => e.position === index)
            if (!wordValue) return false
            else {
                wordValue.correct = wordValue.slug === slugify(wordValue.value.trim()) ? true : false
                if (this.options.filter(e => e.value).length === this.options.length) this.checkResults()
            }
            return true
        },

        getSliderColor() {
            let medium = Math.ceil(this.number_of_choices / 2)

            if (this.correct_choices < medium) return 'red-6'
            else if (this.correct_choices == medium) return 'blue-6'
            else return 'green-6'
        },

        checkResults() {
            this.options.forEach(e => {
                e.correct = e.slug === slugify(e.value.trim()) ? true : false
            })

            this.game_finished = true

            let correctAnswers = this.options.filter(e => e.correct).length

            setTimeout(() => {
                this.correct_choices = correctAnswers
                this.user_score = correctAnswers
                if (this.correct_choices >= this.number_of_choices) this.user_won = true
            }, 750)
        },

        resetGame() {
            this.options = this.game_options.map(e => ( {...e, value: '', correct: undefined }))
            this.correct_choices = 0
            this.user_score = 0
            this.user_won = false

            this.game_words = this.game_words_arr.map(e => e)
            this.game_finished = false
        }
    },

    mounted () {
        this.options = this.game_options.map(e => e)
        this.game_words = this.game_words_arr.map(e => e)
        this.number_of_choices = this.game_options.length
    },

}
</script>

<style lang="stylus" scoped>
.word-chip
    font-weight bold
    color #fff

.word-input
    display inline-block
    font-weight bold
    padding 0rem 0.75rem
    border-radius 1rem

.font-bigger
    font-size 1.1rem

.bg-green-4
    transition all 1.25s ease

.bg-red-4
    transition all 1.25s ease
</style>
